

export const relatorioStyles = ` @media print {
    body {
        margin: 0;
        padding: 0;
    }

    .print {
        page-break-inside: avoid;
    }

    .print-padding {
        padding: 20px;
    }

    .table {
        page-break-inside: auto;
    }

    thead {
        display: table-header-group;
    }

    tfoot {
        display: table-footer-group;
        page-break-before: always;
        page-break-after: always;
        /* Added to ensure the footer appears at the bottom of the page */
        page-break-inside: avoid;
        /* Added to avoid overlapping issues */
    }

    .footer {
        position: fixed;
        bottom: 0;
        width: 100%;
        text-align: center;
        padding: 20px 0;
        display: flex;
        justify-content: space-between;
        /* Align content to the ends */
    }

    /* Avoid cutting off table rows */
    tr:last-child {
        page-break-before: auto;
    }

    tr.table-footer-row {
        page-break-before: always;
    }

    div.print-image,
    div.print-footer {
        display: block !important;
    }

    .table-padding {
        padding-left: 15px;
        padding-right: 15px;
    }

    .page-marker{
        counter-increment: page
    }
}

.tabela-relatorio th,
.tabela-relatorio td {
    padding: 0.25rem !important;
}

.tabela-relatorio th {
    text-align: center;
}
`